import { render } from "./PersonItemList.vue?vue&type=template&id=02f9cc2e"
import script from "./PersonItemList.vue?vue&type=script&lang=js"
export * from "./PersonItemList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__